<template>
    <div id="error">
        <b-card
            bg-variant="warning"
            text-variant="white"
            header="404"
            :footer="wrongURL"
            class="text-center"
        >
            <p class="card-text">Seite nicht gefunden.</p>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "NotFound",
    computed: {
        wrongURL() {
            console.log(this.$route);
            return this.$route.fullPath;
        }
    }
};
</script>

<style scoped>
#error {
    background: white;
    box-shadow: inset 0px 0px 10vmin 6px rgba(0, 0, 0, 0.3);
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.card-text {
    padding: 2px 4px;
}
</style>
